import { render, staticRenderFns } from "./ProductKey.vue?vue&type=template&id=7845c6fc&scoped=true&"
import script from "./ProductKey.vue?vue&type=script&lang=js&"
export * from "./ProductKey.vue?vue&type=script&lang=js&"
import style0 from "./ProductKey.vue?vue&type=style&index=0&id=7845c6fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7845c6fc",
  null
  
)

export default component.exports